module.exports = __webpack_public_path__ + "static/img/cases.25cc8ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cases/cases.png
// module id = FRm/
// module chunks = 94